import { Calculation } from '@servicetitan/financing-api-client';
import { SuggestedPayment } from './SuggestedPayment';
import { Divider, Flex } from '@servicetitan/anvil2';

interface DeferredInterestProps {
    plan: Calculation;
}
export const DeferredInterest = ({ plan }: DeferredInterestProps) => {
    return (
        <Flex style={{ width: '85%' }}>
            <SuggestedPayment plan={plan} isStart eyebrowText="Min. Payment" />
            <Divider vertical spacing="1" style={{ marginLeft: 'auto' }} />
            <SuggestedPayment plan={plan} eyebrowText="Sugg. Payment" />
        </Flex>
    );
};
